import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { RealTimeUpdatesDirective } from 'Src/ng2/shared/services/real-time-updates/real-time-updates.directive';
import { NvDesignLibraryModule } from '../../../nvps-libraries/design/nv-design-library.module';
import { NvMatTooltipModule } from '../../shared/components/nv-mat-tooltip/nv-mat-tooltip.module';
import { RollupTableModule } from '../../shared/components/rollup-list/rollup-table/rollup-table.module';
import { DashboardCircleService } from '../../shared/services/dashboard-circle-service/dashboard-circle-service';
import { ContentToolsModule } from '../../shell/content-tools/content-tools.module';
import { FocusDataService } from './mid-level-dash-data/focus-data/focus-data.service';
import { RollupGroupingDataService } from './mid-level-dash-data/rollup-grouping-data/rollup-grouping-data.service';
import { StudentGroupingDataService } from './mid-level-dash-data/student-grouping-data/student-grouping-data.service';
import { MidLevelDashComponent } from './mid-level-dash.component';
import { VizMadlibComponent } from './viz-mad-lib/viz-mad-lib.component';
import { VizComponent } from './viz/viz.component';
import { VizDataService } from './../../shared/services/viz-services/viz-data-service';
import { VizD3Service } from './../../shared/services/viz-services/viz-d3-service';

@NgModule({
  declarations: [MidLevelDashComponent, VizComponent, VizMadlibComponent, RealTimeUpdatesDirective],
  imports: [
    CommonModule,
    ContentToolsModule,
    NvMatTooltipModule,
    FormsModule,
    MatMenuModule,
    MatCheckboxModule,
    RollupTableModule,
    NvDesignLibraryModule,
  ],
  providers: [
    DashboardCircleService,
    FocusDataService,
    RollupGroupingDataService,
    StudentGroupingDataService,
    VizDataService,
    VizD3Service,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class MidLevelDashModule {}
